export const getQueryStringParams = query => (query
  ? (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      const [key, value] = param.split('=');
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {})
  : {}
);

export const getQuery = locationUrl => (locationUrl.search ? getQueryStringParams(locationUrl.search) : null);

export const isIterable = (obj) => {
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === 'function';
};

export const isRoundInterval = (string) => {
  if (string && !Number.isNaN(string) && string.length === 6) {
    return true;
  }
  return false;
};

export const formatDate = (datePassed, actions) => {
  let postLabel = '';
  const dateJs = new Date(datePassed);
  let dateIta = dateJs.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Europe/Rome' });
  if (dateIta) {
    dateIta = dateIta.split('/');
    if (Array.isArray(dateIta)) {
      dateIta = String(dateIta[0]);
      const localDate = String(dateJs.getDate()).padStart(2, '0');
      if (String(dateIta) !== String(localDate)) {
        postLabel = '*';
        actions.setIsDifferentTZS(true);
      }
    }
  }
  const hours = (`0${dateJs.getHours().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
  const minutes = (`0${dateJs.getMinutes().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
  return `${hours}:${minutes}${postLabel}`;
};
